var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallTimeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stopwatch_1w",
    clipPath: "url(#clip0_1064_1181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.888 18.1294C29.888 25.787 23.68 31.9961 16.0213 31.9961C8.36266 31.9961 2.15466 25.787 2.15466 18.1294C2.15466 10.8313 7.79626 4.86329 14.9547 4.31609V2.12943H13.888V-0.00390625H18.1547V2.12943H17.088V4.31609C20.2219 4.55609 23.0645 5.83396 25.2704 7.80729L26.688 6.38969L28.8213 8.52943L27.2832 10.0676C28.9141 12.3406 29.888 15.1161 29.888 18.1294ZM16.0213 6.39716C9.54133 6.39716 4.288 11.6505 4.288 18.1305C4.288 24.6105 9.54133 29.8628 16.0213 29.8628C22.5013 29.8628 27.7547 24.6105 27.7547 18.1305C27.7547 11.6494 22.5013 6.39716 16.0213 6.39716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5255 19.2967C16.6928 20.1294 15.3412 20.1294 14.5085 19.2967C13.6758 18.464 13.6758 17.1124 14.5085 16.2797C15.3412 15.447 16.6928 15.447 17.5255 16.2797L25.0679 16.2797L25.0679 17.7882L17.7638 19.0056C17.6906 19.1074 17.616 19.2062 17.5255 19.2967Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_1181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallTimeActive);
export default __webpack_public_path__ + "static/media/smallTimeActive.c2fa22241e2dece8e438b8ee7f2aecdc.svg";
export { ForwardRef as ReactComponent };